import DataParser from "../utlits/Dataparser";

export function useAdvancedTaskModule() {
  const modules = DataParser.AllowedCompanyModules() || [];
  return modules.includes("Advanced Task Scheduling");
}
